import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

/** Trigger of the absence early warning rule */
export enum AbsenceEarlyWarningTriggerMode {
    /** N counted absences in a row (PRESENT resets) */
    CONSECUTIVE = 'consecutive',
    /** X counted absences within the last Y logged lessons */
    RATIO = 'ratio',
}

export namespace AbsenceEarlyWarningTriggerMode {
    type Data = { text: string };

    export const Record: Record<AbsenceEarlyWarningTriggerMode, Data> = {
        [AbsenceEarlyWarningTriggerMode.CONSECUTIVE]: {text: 'Fehlen in Folge'},
        [AbsenceEarlyWarningTriggerMode.RATIO]: {text: 'Unregelmäßig (X von Y Stunden)'},
    };

    export const Items = mapRecordToItems(Record);
}

/** Result of the parent mail of an early warning */
export enum AbsenceEarlyWarningMailStatus {
    SENT = 'sent',
    SKIPPED = 'skipped',
    FAILED = 'failed',
    /** Parent mail disabled in the rule */
    DISABLED = 'disabled',
}

export enum AbsenceEarlyWarningMailSkipReason {
    NO_PARENT = 'noParent',
    NO_MAIL = 'noMail',
    OPT_OUT = 'optOut',
    NO_TEMPLATE = 'noTemplate',
    NO_SENDER = 'noSender',
    ERROR = 'error',
}

/** Defaults of the absence early warning rule (user decisions 2026-10-06) */
export const ABSENCE_EARLY_WARNING_DEFAULTS = {
    triggerMode: AbsenceEarlyWarningTriggerMode.CONSECUTIVE,
    threshold: 2,
    window: 5,
    countExcused: false,
    cooldownWeeks: 6,
    /** Newest counted absence must not be older (avoids warnings on old data when a rule is switched on) */
    freshnessDays: 14,
    /** Logs older than this are not evaluated */
    lookbackDays: 120,
} as const;
